import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container mx-auto text-white font-audiowide" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "inline-block pb-2 text-gold text-3xl font-audiowide mb-2" }, " Token Bridge ", -1)
const _hoisted_3 = { class: "flex flex-col space-y-10" }
const _hoisted_4 = { class: "flex items-end" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = {
  key: 0,
  class: "absolute inset-0"
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"absolute inset-0 bg-black opacity-50\"></div><div class=\"absolute inset-0 flex items-center justify-center text-center text-sm\"><svg class=\"animate-spin h-8 w-8 text-white\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><circle class=\"opacity-25\" cx=\"12\" cy=\"12\" r=\"10\" stroke=\"currentColor\" stroke-width=\"4\"></circle><path class=\"opacity-75\" fill=\"currentColor\" d=\"M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z\"></path></svg><p class=\"opacity-50\">Loading pending transactions</p></div>", 2)
const _hoisted_9 = [
  _hoisted_7
]
const _hoisted_10 = { class: "flex items-center h-14 space-x-4 border-b border-white border-opacity-25 text-sm" }
const _hoisted_11 = { class: "w-16" }
const _hoisted_12 = { class: "w-14" }
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4 -ml-1 mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
  })
], -1)
const _hoisted_15 = { class: "inline-flex items-center flex-1" }
const _hoisted_16 = {
  key: 0,
  class: "w-5 h-5 -ml-1 mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M5 11l7-7 7 7M5 19l7-7 7 7"
}, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 1,
  class: "w-5 h-5 -ml-1 mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M19 13l-7 7-7-7m14-8l-7 7-7-7"
}, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 -ml-1 mr-1",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"
  })
], -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Unlock ")
const _hoisted_24 = {
  key: 0,
  class: "absolute inset-0"
}
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"absolute inset-0 bg-black opacity-50\"></div><div class=\"absolute inset-0 flex items-center justify-center text-center text-red-500\"><svg class=\"animate-spin h-8 w-8 text-white\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><circle class=\"opacity-25\" cx=\"12\" cy=\"12\" r=\"10\" stroke=\"currentColor\" stroke-width=\"4\"></circle><path class=\"opacity-75\" fill=\"currentColor\" d=\"M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z\"></path></svg></div>", 2)
const _hoisted_27 = [
  _hoisted_25
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "py-3" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_L1Form = _resolveComponent("L1Form")!
  const _component_L2Form = _resolveComponent("L2Form")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeTab = 'ENTER')),
            class: _normalizeClass(["flex rounded-t px-4 items-center cursor-pointer", [_ctx.activeTab === 'ENTER' ? 'text-black bg-white py-2' : 'text-gray-500 bg-gray-700 py-1']])
          }, " ENTER ", 2),
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'EXIT')),
            class: _normalizeClass(["flex rounded-t px-4 items-center cursor-pointer", [_ctx.activeTab === 'EXIT' ? 'text-black bg-white py-2' : 'text-gray-500 bg-gray-700 py-1']])
          }, " EXIT ", 2)
        ]),
        (_ctx.activeTab === 'ENTER')
          ? (_openBlock(), _createBlock(_component_L1Form, {
              key: 0,
              ref: "l1Form",
              onSentToL2: _ctx.onSentToL2,
              tokens: _ctx.tokens,
              networkId: _ctx.networkId
            }, null, 8, ["onSentToL2", "tokens", "networkId"]))
          : _createCommentVNode("", true),
        (_ctx.activeTab === 'EXIT')
          ? (_openBlock(), _createBlock(_component_L2Form, {
              key: 1,
              ref: "l2Form",
              onWithdrawed: _ctx.onWithdrawed,
              tokens: _ctx.tokens,
              networkId: _ctx.networkId
            }, null, 8, ["onWithdrawed", "tokens", "networkId"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.loadingPending)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactions, (transaction, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "relative",
            key: index
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formatBalance(transaction.value)), 1),
              _createElementVNode("span", _hoisted_12, _toDisplayString(transaction.token.symbol), 1),
              _createElementVNode("a", {
                href: (transaction.inTransitToL1 ? _ctx.config.l2BlockExplorer : _ctx.config.l1BlockExplorer) + '/tx/' + transaction.txHash,
                class: "w-28 inline-flex items-center"
              }, [
                _hoisted_14,
                _createTextVNode(" " + _toDisplayString(transaction.txHash.substring(0,7)), 1)
              ], 8, _hoisted_13),
              _createElementVNode("span", _hoisted_15, [
                (transaction.inTransitToL1)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_16, _hoisted_18))
                  : _createCommentVNode("", true),
                (transaction.inTransitToL2)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_19, _hoisted_21))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(transaction.displayedStatus), 1)
              ]),
              (transaction.readyToRedeem)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    onClick: ($event: any) => (_ctx.unlock(transaction)),
                    class: "btn inline-flex items-center px-3 py-1 text-xs",
                    enabled: _ctx.userIsOnL1()
                  }, {
                    default: _withCtx(() => [
                      _hoisted_22,
                      _hoisted_23
                    ]),
                    _: 2
                  }, 1032, ["onClick", "enabled"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.loading.get(transaction.txHash))
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_27))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _hoisted_28
  ]))
}